import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

// Context
import { PatientsContextProvider } from './context/PatientsContext';
import { GeneralContextProvider } from './context/GeneralContext';
import { FiltersContextProvider } from './context/FiltersContext';
import { ColumnsContextProvider } from './context/ColumnsContext';
import { ProfileContextProvider } from './context/ProfileContext';
import { ToastContextProvider } from './context/ToastContext';
import { ScoresContextProvider } from './context/ScoresContext';
import { ChatProvider } from './context/ChatContext';

// Language
// import i18n (needs to be bundled ;))
import './i18n';
import Spinner from './components/UI/Spinner/Spinner';


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <Suspense fallback={<Spinner />}>
        <PatientsContextProvider>
            <GeneralContextProvider>
                <FiltersContextProvider>
                    <ProfileContextProvider>
                        <ColumnsContextProvider>
                            <ToastContextProvider>
                                <ScoresContextProvider>
                                    <ChatProvider>
                                        <App />
                                    </ChatProvider>
                                </ScoresContextProvider>
                            </ToastContextProvider>
                        </ColumnsContextProvider>
                    </ProfileContextProvider>
                </FiltersContextProvider>
            </GeneralContextProvider >
        </PatientsContextProvider>
    </Suspense>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
